<template>
  <bita-modal
    :id="modalId"
    :title="title"
    :modal-lg="true"
    :isLoading="isLoading"
    @close="onCloseModal"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row">
            <bita-input
              type="text"
              name="name"
              label="نام"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.name"
            />
            <bita-input
              type="text"
              name="family"
              label="نام خانوادگی"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.family"
            />
            <bita-input
              type="text"
              name="username"
              label="نام کاربری"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.username"
            />
            <bita-input
              type="text"
              name="ssn"
              label="کدملی"
              rules="numeric|irani"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.ssn"
            />
            <bita-input
              type="text"
              name="mobile"
              label="شماره تماس"
              rules="required|mobile"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.mobile"
            />
            <bita-input
              type="email"
              name="email"
              label="پست الکترونیک"
              rules="required|email"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.email"
            />
            
<div class="col-lg-4 col-md-6 col-sm-6 password-input-wrapper">
    <bita-input
      :type="showPassword ? 'text' : 'password'"
      name="password"
      label="رمزعبور"
      :subtitle="dataForm.id ? 'در صورت پر شدن تغییر خواهد کرد' : ''"
      :rules="!dataForm.id ? 'required' : ''"
      validation-container-class="col-12"
      input-class="form-control k-password-input"
      v-model="dataForm.password"
    />
    <span class="password-toggle-wrapper" @click="togglePassword">
                   <svg v-if="showPassword" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z"/>
                  <circle cx="12" cy="12" r="3"/>
                </svg>
                <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M17.94 17.94L6.06 6.06"/>
                  <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z"/>
                  <circle cx="12" cy="12" r="3"/>
                </svg>

  </span>
  </div>

            <bita-select
              label="جنسیت"
              name="sex"
              ref="sex"
              :validation-container-class="colWidth"
              rules=""
              input-class="form-control"
              :data-source="sex"
              data-text-field="name"
              data-value-field="id"
              v-model="dataForm.sex"
            />
            <bita-select
              label="دسترسی به مدیریت"
              name="is_administrator"
              :validation-container-class="colWidth"
              input-class="form-control"
              :data-source="[{id: 0,name: 'خیر'},{id: 1,name: 'بله'}]"
              data-text-field="name"
              data-value-field="id"
              v-model="dataForm.is_administrator"
            />
            <bita-multiselect
              label="نقش کاربری"
              ref="role_id"
              name="role_id"
              validation-container-class="colWidth"
              :data-source="propsRoles"
              data-text-field="fa_name"
              data-value-field="id"
              v-model="dataForm.role_id"
              v-show="accessToPanel"
            />
            <bita-select
              label="فروشنده ؟"
              ref="is_supplire"
              name="is_supplire"
              :validation-container-class="colWidth"
              :data-source="[{id: 0,name: 'خیر'},{id: 1,name: 'بله'}]"
              data-text-field="name"
              input-class="form-control"
              data-value-field="id"
              v-model="dataForm.is_seller"
              v-show="accessToPanel"
            />
            <bita-select
              label="لیست تامین کنندگان"
              ref="supplires"
              name="supplires"
              :validation-container-class="colWidth"
              :data-source="propsSupplires"
              data-text-field="seller_store_name"
              input-class="form-control"
              data-value-field="id"
              v-model="dataForm.is_seller_subset"
              v-show="!is_supplire && accessToPanel"
            />
            <bita-uploader
              name="icon"
              label="تصویر"
              rules="size:50"
              ref="uploader"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="dataForm.avatar"
              :icon-url="dataForm.avatar_url"
            />
          </div>
        </div>
      </bita-form>
    </div>
    <div slot="footer">
      <bita-bootbutton
        v-if="!isUpdate()"
        type="primary"
        title="ذخیره"
        icon="fa fa-check"
        btn-width="150px"
        @click.native="handleSubmit()"
      />
      <bita-bootbutton
        v-if="isUpdate()"
        type="primary"
        title="بروزرسانی"
        icon="fa fa-check"
        btn-width="150px"
        @click.native="handleSubmit()"
      />
      <bita-bootbutton
        class="mr-2"
        type="danger"
        title="بستن"
        icon="fas fa-times"
        btn-width="150px"
        data-dismiss="modal"
        @click.native="
          () => {
            $emit('change-status-modal');
          }
        "
      />
    </div>
  </bita-modal>
</template>

<script>
import { collect } from "collect.js";
import { userApi } from "@/api/apiManagement.js";

export default {
  props: {
    modalId: {},
    isLoading: {},
    title: {},
    onSubmit: {},
    entities: {
      type: Array,
    },
    propsRoles: {
      type: Array,
    },
    propsSupplires: {
      type: Array,
    },
    propsData: {
      type: Object,
      default: {
        id: 0,
        name: "",
        family: "",
        ssn: "",
        mobile: "",
        password: "",
        role_id: [],
      },
    },
  },
  data() {
    return {
      colWidth: "col-lg-4 col-md-6 col-sm-6",
      dataForm: { avatar: "" },
      imageData: "",
      showPassword: false,   // اضافه شده
      sex: [
        { id:1 ,name:"آقا"},
        { id:2 ,name:"خانوم"}
      ],
    };
  },
  watch: {
    propsData: function (_data) {
      this.dataForm = _data;
    },
  },
  computed: {
    accessToPanel() {
      return this.dataForm.is_administrator == 1;
    },
    is_supplire() {
      return this.dataForm.is_seller == 1;
    }
  },
  methods: {
    isUpdate() {
      return !!this.propsData.id;
    },
     togglePassword() {
    this.showPassword = !this.showPassword;
  },
    handleSubmit() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          if (this.isUpdate()) this.$emit("on-update", this.dataForm);
          else this.$emit("on-create", this.dataForm);
          this.reset();
        }
      });
    },
    reset() {
      this.$refs.role_id.emptyKendo();
      this.$refs.form.reset();
      this.$refs.uploader.reset();
      this.showPassword = false; // اضافه شده
    },
    setErrors(_errors) {
      this.$refs.form.setErrors(_errors);
    },
    onCloseModal(e) {
      this.$emit('on-close');
      this.reset();
    },
    onModelChange(e) {
      this.$emit("change-model-type", e);
    },
  },
};
</script>

<style scoped>
img {
  width: 75px;
  max-height: 120px;
}
.custom-file-label {
  padding: 0.5rem 4.2rem 0 0;
}
.center-align {
  text-align: center;
}

.password-input-wrapper {
  position: relative;
  display: block;
  margin-bottom: 1rem;
  padding: 0;
}

.password-toggle-wrapper {
  position: absolute;
  right: 15px; /* افزایش فاصله از راست */
  top: 46px; /* تنظیم موقعیت عمودی */
  transform: translateY(-50%);
  z-index: 1000;
  cursor: pointer;
  padding: 6px 8px;
  background: transparent;
  border-radius: 4px;
  transition: all 0.2s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
}


</style>
<style>
  .k-password-input {
  padding-right: 70px; /* فاصله برای آیکن */
  padding-left: 15px;
  text-align: center;
}
</style>